import type { DocumentListRow } from "~/features/orders/orderList/useOrderListState";
import type { OrderData } from "~/domains/orders/types/modelsV2";

export const isErrorEntry = (row: DocumentListRow<OrderData>) => {
  return row.data.soNumber === "-";
};

export const addStatusHover = (status: string) => {
  return status === "PR";
};
